<template>
    <div class="row featured-product-slider" :class="className">
        <div class="col-12" :id="id + '-slider'" :class="id + '-content'">
            <div v-if="items && items.length > 0">
                <VueSlickCarousel
                    ref="slick"
                    v-bind="slickSettings"
                    class="featured-product-content"
                >
                    <div v-for="item in items" class="featured-el news">
                        <div class="hover-effect"></div>
                        <a class="image" :href="disableLink === 'no' ? item.href : 'javascript:void(0)'"  :v-if="!item.image_url || item.image_url === 0">
                             <picture v-if="item.image_url && item.image_url.length > 0">
                                <img v-lazy="item.image_url" :alt="item.title" loading="lazy">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden"></span>
                                </div>
                            </picture>
                        </a>
                        <a class="title" :href="disableLink === 'no' ? item.href : 'javascript:void(0);'"  v-text="item.title"></a>
                        <div class="priceRange">de R$ 104,30 por <div class="final">R$ 92,50</div></div>
                        <a :href="disableLink === 'no' ? item.href + '?buynow=true' : 'javascript:void(0);'"  class="btn-green buynow-btn" v-if="showButton === 'yes'">
                          <div class="icon" v-html="shoppingIcon"></div>
                          <label> {{$lang.get('page.sellers.buynow')}}</label>
                        </a>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        components: {VueSlickCarousel},
        props: ['id', 'items', 'className', 'labelReadMore', 'featured', 'showButton', 'disableLink'],

        watch: {
            items: function() {
                this.$nextTick(() => {
                    if (!this.$refs.slick) return;
                    this.$refs.slick.$emit('reInit');
                });
            },
        },

        data: () => { return {
            currentFilter: '',
            shoppingIcon: '',
            slickSettings: {
                arrows: true,
                adaptiveHeight: false,
                draggable: true,
                slidesToShow: Math.round($(".main-container").width() / 232),
                dots: false,
                infinite: true,
                speed: 300,
                variableWidth: false,
                responsive: [
                  {
                    breakpoint: 800,
                    settings: {
                      centerMode: true,
                      centerPadding: '40px',
                      slidesToShow: 1,
                    }
                  }
                ]
            }
        }},

      beforeMount: function () {
          let element = document.getElementById('shopping-icon');
          if(element !== undefined) {
            this.shoppingIcon = document.getElementById('shopping-icon').innerHTML;
          }

          if(this.id === 'featured') {
            this.slickSettings.slidesToShow = 5;
            this.slickSettings.responsive = [
              {
                breakpoint: 1920,
                settings: {
                  slidesToShow: Math.round($(".main-container").width() / 232),
                }
              },
              {
                breakpoint: 1900,
                settings: {
                  slidesToShow: 5,
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 950,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
          }
        },
    }
</script>
